const initialState = {
    profile: {}
};
  
const companyProfileReducer = (state = initialState, action) => {
switch (action.type) {
    case 'SET_COMPANY_PROFILE': {
        return {
                ...state,
                profile: action.payload
            }
        }
    case 'UPDATE_COMPANY_PROFILE_INFO': {
        return {
            ...state,
            profile: {
                ...state.profile,
                [action.payload.key]: action.payload.value
            }
        }
    }
    default: {
        return state;
    }
}
};

export default companyProfileReducer;